<template>
  <div
    class="d-flex flex-column main-wrapper"
    style="
      padding-left: 6px !important;
      padding-right: 6px !important;
      height: 100vh;
      overflow-y: scroll;
      background: #2B0000;
      /* background-attachment: fixed; */
    "
  >
    <div
      class="account-container-wrapper d-flex pl-0 mt-2 py-2"
      style="background: rgba(255,255,255,0.2);
  /* border-radius: 12px;
  padding: 16px; */
  color: #fff !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);"
    >
      <div class="col-5 my-auto">
        <img
          src="https://storage.googleapis.com/spacetech2/shweohhh/logo%20icon_1%20(1).png"
          style="width: 8rem; height: 8rem;"
          alt=""
        >
      </div>

      <div class="col-7 p-0">
        <div class="pt-2">
          <div class="d-flex text-white">
            <p
              class="mb-1"
              style="width: 100px; font-weight: 500;"
            >
              {{ $t('setting.name') }}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">: {{ $store.state.authUser.user_name }}
            </p>
          </div>
          <div class="d-flex text-white">
            <p
              class="mb-1"
              style="width: 100px; font-weight: 500;"
            >
              {{ $t('setting.balance') }}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">:
              <b>{{ Number($store.state.amount).toLocaleString() }}</b>
              MMK
            </p>
          </div>
          <!-- <div class="d-flex text-white">
            <p class="mb-1" style="width: 100px; font-weight: 500;">
                        {{$t('setting.withdraw')}}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">:
              <b>{{ Number($store.state.totalWithdraw).toLocaleString() }}</b>
            MMK </p>
          </div> -->
          <div class="d-flex text-white">
            <p
              class="mb-1"
              style="width: 100px; font-weight: 500;"
            >
              {{ $t('setting.phone') }}</p>
            <p class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">: {{
              blurLastFiveCharacters($store.state.authUser.phone) }} </p>
          </div>
          <div
            class="d-flex"
            v-if="$store.state.authUser.commissioner"
          >
            <p
              class="mb-1 text-nowrap text-white"
              style="width: 100px"
            >
              <b>{{ $t('setting.upper_line') }}</b>
            </p>
            <p
              class="mb-1 text-white"
              style="font-weight: 400;"
            >: {{ $store.state.authUser.commissioner }}</p>
          </div>

        </div>
      </div>
    </div>

    <!-- <div class="account-container-wrapper d-flex pl-0 mt-2 py-2">
    <div class="col-12 justify-content-between my-auto d-flex flex-column py-3">
        <span class="mx-auto" style="color: #51565b;">{{$t('setting.total_bonus')}}    <span class="px-3">:</span>  <span class="MuiTypography-root MuiTypography-body1 css-eurmd1 mb-1">{{ Number($store.state.authUser.bonus_amount).toLocaleString() }} MMK</span></span>
        <span class="text-sm px-3 text-muted pt-3"> <span style="color: #51565b;">{{$t('setting.remark')}} <span class="mx-2">-</span> </span>{{$t('setting.bonus_remark')}}</span>
      </div>
  </div> -->

    <div class="account-container-wrapper d-flex pl-0 mt-2 py-2">
      <div class="col-12 justify-content-between my-auto d-flex">
        <div
          class="col-3 text-center pt-1"
          style="cursor: pointer"
          @click="$router.push('/deposit')"
        >
          <img
            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/deposit-ak47-new.png"
            style="width: 2.3rem; height: 2.3rem"
            alt=""
          >
          <div
            class="mx-auto mt-1 text-sm text-nowrap"
            style="color: #fff; font-weight: 300;"
          >
            {{ $t('setting.deposit') }}
          </div>
        </div>
        <div
          class="col-3 text-center pt-1"
          style="cursor: pointer"
          @click="$router.push('/withdraw')"
        >
          <img
            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/withdraw-ak47-new.png"
            style="width: 2.3rem; height: 2.3rem"
            alt=""
          >
          <div
            class="mx-auto mt-1 text-sm text-nowrap"
            style="color: #fff; font-weight: 300;"
          >
            {{ $t('setting.withdraw') }}
          </div>
        </div>
        <div
          class="col-3 text-center pt-1"
          style="cursor: pointer"
          @click="$router.push('/betslip-history')"
        >
          <img
            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/shweohh_vouchers.png"
            style="width: 2.3rem; height: 2.3rem"
            alt=""
          >
          <div
            class="mx-auto mt-1 text-sm text-nowrap"
            style="color: #fff; font-weight: 300;"
          >
            {{ $t('setting.voucher') }}
          </div>
        </div>
        <div
          class="col-3 text-center pt-1"
          style="cursor: pointer"
          @click="$router.push('/history')"
        >
          <img
            src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/history-ak47-new.png"
            style="width: 2.3rem; height: 2.3rem"
            alt=""
          >
          <div
            class="mx-auto mt-1 text-sm text-nowrap"
            style="color: #fff; font-weight: 300;"
          >
            {{ $t('setting.transaction') }}
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="account-container collect-section my-2">
      <div class="py-3 px-4 d-flex justify-content-between">
          <div class="text-white">
              <p class="amount m-0">{{ Number($store.state.authUser.loss_amount ?? 0).toLocaleString() }} Ks</p>
              <span style="color: #D5C298;">
                  <small>
                      ည ၁၂ နာရီကျော်သည်နှင့် သင့် ရှုံးကြေး၏  <strong class="mx-2" style="color: white !important; font-size: 1.2rem !important;"> ၁၀% </strong> ကိုဤနေရာတွင် ပေါင်းထည့်မည်။ ပေါင်းထည့်ပေးသော ရှုံးကြေး၏ ၃ ဆ အနိုင်ရရှိမှသာ ထုတ်ပေးပါမည်။ ကျန်လက်ကျန်ငွေများကို Server မှ ပယ်ဖျက်လိုက်ပါမည်။
                  </small>
              </span>
          </div>
          <button
              class="btn main-btn"
              @click="collectAmount"
          >
              <div v-if="!isCollecting">
                  ရယူမည်
              </div>

              <Loading
                  color="#fff"
                  v-if="isCollecting"
                  size="24"
                  class="px-4 py-0"
              />
          </button>
      </div>
  </div> -->

    <div class="px-0 col-12 pl-0 side-nav-bar-custom my-2">
      <nav
        class="side-nav my-0"
        style="background: #590007;
    border-radius: 7px;
    "
      >
        <div>
          <div>
            <!-- Nav items -->
            <ul class="navbar-nav-custom">
              <li class="nav-items">
                <div class="nav-link">
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-user.png"
                    style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;"
                    alt=""
                  >
                  <span style="color: #fff;">{{ $t('setting.name') }} - {{ $store.state.authUser.name }} </span>
                </div>
              </li>
              <li
                class="nav-items"
                data-toggle="modal"
                data-target="#editUserPassword"
              >
                <div class="nav-link d-flex justify-content-between">
                  <div>
                    <!-- <i class="fas fa-key mr-3" style="color: white; font-weight: 500;"></i> -->
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/reset-password--new-ak47.png"
                      style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;"
                      alt=""
                    >
                    <span style="color: #fff;">{{ $t('setting.update_password') }}</span>
                  </div>
                  <div style="color: #fff;">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </li>
              <!-- <li
              class="nav-items"
              @click="() => $router.push('/banking')"
            >
              <div class="nav-link d-flex justify-content-between">
                <div>
                  <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-bank.png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #fff;">{{$t('setting.bank_account')}}</span>
                </div>
                <div>
                  <i style="color: #fff;" class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li> -->
              <!-- <li
              class="nav-items"
              @click="() => $router.push('/level')"
            >
              <div class="nav-link d-flex justify-content-between">
                <div>
                  <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-vip.png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #fff;">{{$t('setting.vip_club')}}</span>
                </div>
                <div>
                  <i style="color: #fff;" class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li> -->
              <!-- <li
              class="nav-items"
              @click="() => $router.push('/commission')"
            >
              <div class="nav-link d-flex justify-content-between">
                <div>
                  <img src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/melon-zeed/icons/add-group%20(1).png" style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;" alt="">
                  <span style="color: #fff;">{{$t('setting.invite_friend')}}</span>
                </div>
                <div>
                  <i style="color: #fff;" class="fas fa-chevron-right"></i>
                </div>
              </div>
            </li> -->
              <li
                v-if="!$store.state.authUser.commissioner"
                class="nav-items"
                data-toggle="modal"
                data-target="#editUserInvitationCode"
              >
                <div class="nav-link d-flex justify-content-between">
                  <div>
                    <img
                      src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_code.png"
                      style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;"
                      alt=""
                    >
                    <!-- <i class="fas fa-code mr-3" style="color: #93a1c0; font-size: 1.2rem;"></i> -->
                    <span class="nav-link-text text-white">{{
                      $store.state.language === 'en'
                        ? 'Add Agent Code'
                        : 'ကိုယ်စားလှယ်ကုဒ် ထည့်မည်။'
                    }}</span>
                  </div>
                  <div>
                    <i class="fas fa-chevron-right text-white"></i>
                  </div>
                </div>
              </li>

              <li class="nav-items">
                <div
                  class="nav-link d-flex justify-content-between"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <div id="navbar-language">
                    <img
                      src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-language.png"
                      style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;"
                      alt=""
                    >
                    <span style="color: #fff;">{{ $t('setting.update_language') }}</span>
                  </div>

                  <div
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="navbar-language"
                  >
                    <a
                      class="dropdown-item"
                      @click="setLangLocalstorage('en')"
                    ><img
                        src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />
                      {{ $t('en') }}</a>
                    <div class="dropdown-divider"></div>
                    <a
                      class="dropdown-item"
                      @click="setLangLocalstorage('mm')"
                    ><img
                        src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t('mm') }}</a>
                    <div class="dropdown-divider"></div>
                    <a
                      class="dropdown-item"
                      @click="setLangLocalstorage('cn')"
                    ><img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t("cn") }}</a>
                    <div class="dropdown-divider"></div>
                    <a
                      class="dropdown-item"
                      @click="setLangLocalstorage('th')"
                    ><img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png"
                        alt=""
                        class="mr-2"
                        style="width: 20px; height: 20px"
                      />{{ $t("th") }}</a>
                  </div>

                  <div style="color: #fff;">
                    <i class="fas fa-chevron-right"></i>
                  </div>
                </div>
              </li>

              <li
                class="nav-items"
              >
                <router-link
                  to="/promotions"
                  class="nav-link d-flex justify-content-between p-0"
                  style="text-decoration: none;"
                >
                  <div class="nav-link">
                    <div>
                      <img
                        src="https://yy24gld.sgp1.cdn.digitaloceanspaces.com/shweohhh/warning.png"
                        style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;"
                        alt=""
                      >
                      <!-- <i class="fas fa-code mr-3" style="color: #93a1c0; font-size: 1.2rem;"></i> -->
                      <span class="nav-link-text text-white">{{ $t('footer.promotion') }}</span>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>

            <!-- Divider -->
            <hr class="my-3" />
            <!-- Navigation -->
            <ul class="navbar-nav-custom mb-md-3">
              <li class="nav-items">
                <div
                  class="nav-link active active-pro"
                  @click="logout()"
                >
                  <img
                    src="https://space-tech.sgp1.cdn.digitaloceanspaces.com/ak47/general/ak47-logout.png"
                    style="width: 25px; height: 25px; margin-left: -0.5rem; margin-right: 1rem;"
                    alt=""
                  >
                  <!-- <i class="ni ni-lock-circle-open mr-3" style="color: dark; font-weight: 500;"></i> -->
                  <span style="color: #fff;">{{ $t('setting.logout') }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>

    <!-- ==== modal for user password edit ==== -->
    <div
      class="modal fade"
      id="editUserPassword"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal- modal-dialog-centered modal-sm"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body">
            <div class="card border-0 mb-0">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="form-group">
                  {{ $t('setting.old_password') }}
                  <div class="mt-2 input-group">
                    <input
                      class="form-control"
                      v-model="password.old"
                    />
                  </div>
                  <span class="text-danger">{{ errors.old }}</span>
                </div>
                <div class="form-group">
                  {{ $t('setting.new_password') }}
                  <div class="mt-2 input-group">
                    <input
                      class="form-control"
                      v-model="password.new"
                    />
                  </div>
                  <span class="text-danger">{{ errors.new }}</span>
                </div>
                <div class="form-group">
                  {{ $t('setting.confirm_password') }}
                  <div class="mt-2 input-group">
                    <input
                      class="form-control"
                      v-model="password.confirm"
                    />
                  </div>
                  <span class="text-danger">{{
                    errors.confirm || errors.confirmPassword
                  }}</span>
                </div>
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="changeNewPassword"
                  >
                    <div v-if="!isConfirm">
                      {{ $t('setting.update') }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isConfirm"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ==== modal for user commission code edit ==== -->
    <div
      class="modal fade"
      id="editUserInvitationCode"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-form"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal- modal-dialog-centered modal-sm"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-body">
            <div class="border-0 mb-0">
              <div class="card-body px-lg-5 py-lg-5">
                <div class="form-group">
                  {{
                    $store.state.language === 'en'
                      ? 'Enter Agent Code'
                      : 'ကိုယ်စားလှယ် ကုဒ်ထည့်ပါ။'
                  }}
                  <div class="mt-2 input-group">
                    <input
                      class="form-control"
                      v-model="code.currentCode"
                    />
                  </div>
                  <span class="text-danger">{{ errors.currentCode ?? error }}</span>
                </div>
                <div class="text-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="updateInviteCode"
                  >
                    <div v-if="!isConfirm">
                      {{
                        $store.state.language === 'en'
                          ? 'Confirm'
                          : 'အတည်ပြုမည်'
                      }}
                    </div>

                    <Loading
                      color="#ffffff"
                      v-if="isConfirm"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      code: {
        currentCode: '',
      },
      isConfirm: false,
      errors: {},
      isCollecting: false,
      error: null
    };
  },
  methods: {
    updateInviteCode() {
      this.errors = {};
      if (!this.code.currentCode) {
        this.errors.currentCode =
          this.$store.state.language === 'en'
            ? 'Agent Code required'
            : 'မိတ်ဆက် ကုဒ်ထည့်ပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUserInvitationCode();
        })
        .catch(() => { });
      this.isConfirm = false;
      return true;
    },
    async updateUserInvitationCode() {
      try {
        const res = await axios.post(
          '/auth/userInvitationCodeUpdate',
          this.code,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.code = {};
        this.errors = {};
        $('#editUserInvitationCode').modal('hide');
        this.fetchUser();
      } catch (error) {
        if (error.response && error.response.data) {
          const responseErrors = error.response.data.errors;
          if (responseErrors.code) {
            this.error = responseErrors.code[0];
            console.log(this.errors)
          }
        }
      }
    },
    async collectAmount() {
      try {
        this.isCollecting = true;
        await axios.get('/claim-loss-return',
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        this.fetchUser();
        Toast.success(
          this.$store.state.language === 'en'
            ? 'Success!'
            : 'Success!'
        );
        this.isCollecting = false
      } catch (error) {
        this.isCollecting = false
        Toast.fail(
          this.$store.state.language === 'en'
            ? 'Fail!'
            : 'Fail!'
        );
      }

    },
    ...mapActions(['logoutUser', 'fetchUser']),
    blurLastFiveCharacters(inputString = "0000000000") {
      // Get the length of the input string
      const length = inputString.length;

      // Check if the input string has at least five characters
      if (length >= 7) {
        // Extract the first part of the string
        const firstPart = inputString.substring(length - 5, length);

        // Create a string with '*' characters for the last five numbers
        const blurredCharacters = '*'.repeat(length - 5);

        // Concatenate the first part and the blurred numbers
        const blurredString = blurredCharacters + firstPart;

        return blurredString;
      } else {
        // Return the input string unchanged if it has less than five characters
        return inputString;
      }
    },
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
      this.$i18n.locale = language
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === 'en'
            ? 'Old password required'
            : 'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။';
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === 'en'
            ? 'New password required'
            : 'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။';
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === 'en'
            ? 'Confirm password required'
            : 'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။';
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === 'en'
            ? 'New passwords not match'
            : 'လျှို့ဝှက်နံပါတ် မတူညီပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => { });
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        const res = await axios.post(
          '/auth/userPasswordChange',
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.password = {};
        this.errors = {};
        $('#editUserPassword').modal('hide');
      } catch (error) {
        Toast.fail(
          this.$store.state.language === 'en' ? 'Fail' : 'ကျရှုံးသည်။'
        );
      }
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          if (this.$route.path === '/home') {
            // this.$router.go();
          } else {
            this.$router.push('/home');
            // this.$router.go();
          }
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
  },
  async mounted() {
    // this.$store.commit('setLoading', true);
    const authUser = await this.fetchUser();
    // this.$store.commit('setLoading', false);
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    if (authUser && !authUser.is_verified) {
      this.$router.push('/auth/verify');
    }
  },
};
</script>
<style scoped>
.main-btn {
  background: #000000 !important;
  border: 1px solid rgb(240 97 38 / 1) !important;
  box-shadow: none !important;
  color: white !important;

  border-radius: 20px;
  height: 30px;
  min-width: 6rem;
  border: 0;
  padding: 0 1rem;
  font-size: .8rem;
  text-align: center;
  box-shadow: none;

  &:hover {
    color: #fff;
  }
}


.collect-section {
  position: relative;
  background: #590007;
  border-radius: 7px;
  /* border: 1.5px solid #24221E; */

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: url('../../assets/stars.png'); */
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.3;
    pointer-events: none;
  }

  .amount {
    font-size: 1.3rem;
    font-weight: bolder;
    line-height: normal;
  }
}

.error {
  margin-bottom: 13px;
  height: 40px;
  display: flex;
  align-items: center;
  color: red;
  border: 1px solid red;
  border-radius: 8px;
  padding: 0px 15px;
  /* background: #ff000014; */
  font-weight: bold;
}

.account-container-wrapper {
  width: auto;
  height: 200px;
  /* border-radius: 5px; */
  color: black !important;
  /* background: #552A07; */
  /* box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px; */
  /* background: #282A31;  */
  background: #590007;
  border-radius: 7px;
  /* border: 1.5px solid #24221E; */
  /* box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1); */
  /* backdrop-filter: blur(10px);-webkit-backdrop-filter: blur(0.5px) !important; */
}
</style>
